import styled from 'styled-components'

import ViewportContainer from '../ViewportContainer/ViewportContainer'
import pxToRem from '../../utils/pxToRem'
import { deviceMax } from '../../theme/breakpoints'
import { NAVBAR_HEIGHT } from '../../theme/constants'

export const StyledViewportContainer = styled(ViewportContainer)`
  width: 100%;
`

export const StyledDropdown = styled.div`
  flex: 1;
  justify-content: center;
  display: flex;
  height: inherit;
`

export const HoverLine = styled.div`
  position: absolute;
  top: ${pxToRem(NAVBAR_HEIGHT.desktop - 5)};
  display: ${({ $isOpen, $selected }) =>
    $isOpen || $selected ? 'block' : 'none'};
  border-radius: ${pxToRem(5)} ${pxToRem(5)} 0 0;
  width: 100%;
  height: ${pxToRem(5)};
  background-color: ${({ theme }) => theme.colors.primary.blue};
  @media ${deviceMax.tablet} {
    top: ${pxToRem(NAVBAR_HEIGHT.mobile - 5)};
  }
`

export const StyledDropdownHeader = styled.div`
  position: relative;
  align-items: center;
  display: flex;
  font-weight: ${({ theme }) => theme.fonts.weight.normal};

  &:active,
  &:hover {
    /* add bold on text without change container size */
    -webkit-text-stroke-width: ${pxToRem(0.7)};
    -webkit-text-stroke-color: ${({ theme }) => theme.colors.primary.white};
  }

  &:hover > ${HoverLine} {
    display: block;
  }
`

export const StyledDropdownList = styled.div`
  align-items: flex-start;
  position: absolute;
  top: ${pxToRem(NAVBAR_HEIGHT.desktop)};
  left: 0;
  display: ${({ $isOpen }) => ($isOpen ? 'flex' : 'none')};
  width: 100%;
  background-color: ${({ theme }) => theme.colors.unique.black};
  font-weight: ${({ theme }) => theme.fonts.weight.normal};
  gap: ${pxToRem(24)};
`

export const StyledSeparator = styled.div`
  width: ${pxToRem(2)};
  background-color: ${({ theme }) => theme.colors.primary.blue};
`

export const StyledDropdownItems = styled.ul`
  display: flex;
  flex-direction: column;
  gap: ${pxToRem(24)};
`

export const StyledAdditionnalReferenceDropdownItem = styled.ul`
  display: flex;
  gap: ${pxToRem(24)};
`
